module.exports = __webpack_public_path__ + "4744ac910ed01198389513ad8292ff93.pdf";